import React from 'react';
import styled from 'styled-components/macro';

const Info = () => {
  return(
    <InfoContainer>
      <InfoTitle>Overview of the SciScore Analysis Process</InfoTitle>
      <ProcessImage><img src='/img/SciScoreProcess.svg' width='1000' alt={'SciScore Process'}/></ProcessImage>
    </InfoContainer>);
}

export default Info;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;
`;

const InfoTitle = styled.div`
  display: flex;
  width: 100%;
  font-size: 20px;
  margin-bottom: 10px;
`;

const ProcessImage = styled.div`
  display: flex;
  width: 100%;
`;